import request from '@/utils/request'
// //医生列表
export function getDocterList(query) {
  return request({
    url: '/admin/bl/getDocterList',
    method: 'post',
    data: query
  })
}

// //获取医生详情
export function getDocter(query) {
    return request({
      url: '/admin/bl/getDocter',
      method: 'post',
      data: query
    })
  }
  //医生保存
  export function addDocter(query) {
    return request({
      url: '/admin/bl/addDocter',
      method: 'post',
      data: query
    })
  }
   //医生保存
   export function updateDocter(query) {
    return request({
      url: '/admin/bl/updateDocter',
      method: 'post',
      data: query
    })
  }
  //医生删除
export function delDocter(query) {
  return request({
    url: '/admin/bl/delDocter',
    method: 'post',
    data: query
  })
}
//诊断病例删除
export function delDiagnosisCategory(query) {
    return request({
      url: '/admin/bl/delDiagnosisCategory',
      method: 'post',
      data: query
    })
  }
  export function updateDiagnosisCategory(query) {
    return request({
      url: '/admin/bl/updateDiagnosisCategory',
      method: 'post',
      data: query
    })
  }
  export function getDiagnosisCategory(query) {
    return request({
      url: '/admin/bl/getDiagnosisCategory',
      method: 'post',
      data: query
    })
  }
  
// //预约列表导出
// export function subscribeListExcel(query) {
//   return request({
//     url: '/subscribeListExcel',
//     method: 'post',
// 	responseType:'blob',
//     data: query
//   })
// }
// //病例列表
export function list(query) {
  return request({
    url: '/admin/bl/list',
    method: 'post',
    data: query
  })
}

// //病例列表
export function del(query) {
  return request({
    url: '/admin/bl/del',
    method: 'post',
    data: query
  })
}

// //诊断病例列表
export function getDiagnosisCategoryList(query) {
    return request({
      url: '/admin/bl/getDiagnosisCategoryList',
      method: 'post',
      data: query
    })
  }

//诊断病例保存
export function addDiagnosisCategory(query) {
    return request({
      url: '/admin/bl/addDiagnosisCategory',
      method: 'post',
      data: query
    })
  }


  // //前台账号列表
export function getHomeUserList(query) {
  return request({
    url: '/admin/bl/getHomeUserList',
    method: 'post',
    data: query
  })
}

//前台账号保存
export function addHomeUser(query) {
  return request({
    url: '/admin/bl/addHomeUser',
    method: 'post',
    data: query
  })
}

//前台账号删除
export function delHomeUser(query) {
  return request({
    url: '/admin/bl/delHomeUser',
    method: 'post',
    data: query
  })
}

//前台账号查看
export function getHomeUser(query) {
  return request({
    url: '/admin/bl/getHomeUser',
    method: 'post',
    data: query
  })
}

//前台账号修改
export function updateHomeUser(query) {
  return request({
    url: '/admin/bl/updateHomeUser',
    method: 'post',
    data: query
  })
}

